import { render, staticRenderFns } from "./bidDemand.vue?vue&type=template&id=58262f4c&scoped=true&lang=pug"
import script from "./bidDemand.vue?vue&type=script&lang=js"
export * from "./bidDemand.vue?vue&type=script&lang=js"
import style0 from "./bidDemand.vue?vue&type=style&index=0&id=58262f4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58262f4c",
  null
  
)

export default component.exports